function hideModal(modal) {
  if (!modal) {
    return;
  }
  // Hide the modal.
  modal.classList.remove('block');
  modal.classList.add('hidden');
  // Unlock the html and body scroll.
  document.documentElement.style.overflow = 'auto';
  document.body.style.overflow = 'auto';
}

export async function render() {
  // Get all modals on the page
  const modals = document.querySelectorAll('.frcg-modal');
  // Loop through the modals and add event listeners
  for (const modal of modals) {
    // Attach click on scrim to close modal
    modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('frcg-modal')) {
        hideModal(modal);
      }
    });
    // Attach click on close button to close modal
    const closeButtons = modal.querySelectorAll('.frcg-modal__close');
    for (const closeButton of closeButtons) {
      closeButton.addEventListener('click', () => {
        hideModal(modal);
      });
    }
    // Attach click on open button to open modal, getting the toggledBy data attribute from the modal
    const openButtonSelector = modal.getAttribute('data-toggled-by');
    if (openButtonSelector) {
      const openButton = document.querySelector(openButtonSelector);
      if (openButton) {
        openButton.addEventListener('click', () => {
          modal.classList.add('block');
          modal.classList.remove('hidden');
        });
      }
    }
  }
}